import { combineReducers } from 'redux';
// Import reducers
import table from './video_assets_params_panel_reducer';
import form from './video_assets_params_form_reducer';

export default combineReducers({
	table,
	form
});
